import React, { useState, useEffect, useCallback } from "react";
import './Maintenance.css';
import {CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from '../../api/apiClient';
import {CreateTable} from './../ManageTable';
import {token, domain} from './../Security';
// icon
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function Ecola() {
    var header = [
        "ID",
        "Amount",
        ""
    ]
    var accessor = [
        "id",
        "amount",
        "manage"
    ]

    const [ecola, setEcola] = useState([]);
     // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("----Select filter----");
    // Add
    const [showEditForm, setShowEditForm] = useState(false);
    const [amount, setAmount] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end


    const apiUrl =  domain + "/api/Ecola";

    const fetchData = useCallback(async () => {
        await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setEcola(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("----Select filter----")
                break;
            case 1:
                setSearchPlaceholder("Search by ecola id")
                break;
            default:
                setSearchPlaceholder("----Select filter----")
                break;
        }
    }, [fetchData, filterDataIndex]);

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                return;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setEcola(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            amount: amount,
        };

        try {
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            fetchData(); // Assuming fetchData() fetches the updated data for the table
            setAmount("");
            setShowEditForm(false); // Hide the add form
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        }

        setShowEditForm(false);
    };

    const addHandleClick = (data) => {
        setShowEditForm(true);
        setAmount(data.amount);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className="MainBody row">
                <div className="LeftSpace"></div>
                <div className="BodySpace">
                    <div className="MainteInfo shadow-xl">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Maintenance >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Ecola"}</span>
                            </div>
                            <h3>Ecola</h3>
                        </div>
                        <div className="mainte-body">
                            {Filter(setFilterDataIndex)}
                            <div className="mainte-body-top row">
                                {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e)=>handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={ecola}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={addHandleClick}
                                />
                                {ecola.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div> {/*<p>No records to display</p>*/}</div>
                                )}
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    amount={amount}
                    setAmount={setAmount}
                    handleSubmit={handleSubmit}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
        </div>
    )
}
function EditForm({isOpen, 
    onClose,  
    amount,
    setAmount,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(amount === ""){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };
    
    return (
        <>
        <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
            {isOpen && (
            <div className="modal">
                <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Ecola</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Amount</div>
                            <div className="info-item-input">
                                <input
                                type="number"
                                id="amount"
                                placeholder="Amount"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: amount === "" && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EcolaId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EcolaId">Ecola Id</option>
            </select>
        </div>
    );
};
export default Ecola
